/*
Copyright MITSUBISHI Elec.
*/

//---------------------------------------------
// BlenderDataMarkerプラグイン
//---------------------------------------------

(function() {
	'use strict';

	var helpers = Chart.helpers;

	/**
	 * 画像管理クラス
	 *
	 * @module BlenderChart
	 * @class ImageManager
	 */
	var ImageManager = (function() {

		// ステータス
		var Status = Object.freeze({
			// 読み込み中
			LOADING: 1,
			// 完了
			COMPLETE: 2,
			// エラー
			ERROR: -1
		});

		/**
		 * 読み込み完了イベントハンドラ
		 *
		 * @private
		 * @this {ImageManager}
		 * @param e {Event} イベントオブジェクト
		 */
		function onLoadEvent(e) {
			var me = this;
			if (me.status === Status.LOADING) {
				me.status = Status.COMPLETE;

				if (me._requestRendering) {
					me._chart.render(BlenderChart.UPDATE_CONFIG_IMMEDIATELY);
				}
				me._requestRendering = false;
			}
		};

		/**
		 * 画像エラーイベント
		 *
		 * @private
		 * @this {ImageManager}
		 * @param e {Event} イベントオブジェクト
		 */
		function onErrorEvent(e) {
			var me = this;
			if (me.status === Status.LOADING) {
				me.status = Status.ERROR;
				me._requestRendering = false;
			}
			if (console && typeof console.error === 'function') {
				console.error('マーカー画像の読み込みに失敗しました。', e.target.src);
			}
		};

		/**
		 * コンストラクター
		 *
		 * @constructor
		 * @param chart {BlenderChart} BLEnDerChartインスタンス
		 * @param url {string} 画像のURL
		 */
		function ImageManager(chart, url) {
			var me = this;

			me._chart = chart;
			me._requestRendering = false;

			if (!url) {
				me.status = Status.ERROR;
				return;
			}
			me.setUrl(url);
		};

		var proto = ImageManager.prototype;

		/**
		 * 画像URLをセットする
		 *
		 * @method setUrl
		 * @param url {string} 画像URL
		 */
		proto.setUrl = function(url) {
			var me = this;

			if (!url || me._url === url) {
				return;
			}

			me.status = Status.LOADING;
			me._requestRendering = false;

			var image = me.image || (me.image = new Image());

			image.onload = onLoadEvent.bind(me);
			image.onerror = onErrorEvent.bind(me);

			me._url = url;
			image.src = url;
		};

		/**
		 * 画像読み込み完了時にレンダリング要求を行う。
		 *
		 */
		proto.setRequestRendering = function() {
			this._requestRendering = (this.status === Status.LOADING);
		};

		/**
		 * 画像の読み込みが完了している場合は true を返す。
		 *
		 * @method isComplete
		 * @return {boolean} true: 読み込み完了／false：読み込み中あるいはエラー
		 */
		proto.isComplete = function() {
			return (this.status === Status.COMPLETE);
		};

		/**
		 * グラフ上に画像を描画する。
		 *
		 * @method draw
		 * @param ctx {CanvasRenderingContext2D} 描画コンテキスト
		 * @param box {object} 描画する領域
		 * @param view {object} 関連する要素の表示モデルデータ
		 * @param opts {options} プラグインのオプション
		 */
		proto.draw = function(ctx, box, view, opts) {
			var me = this;

			if (!me.isComplete()) {
				return;
			}

			// 描画位置
			var isHorizontal = view.horizontal;
			var centerX, centerY;

			if (isHorizontal) {
				centerX = (opts.position === 'top') ? box.right : box.left;
				centerY = view.y;

				if (centerY < box.top || box.bottom < centerY) {
					return;
				}
			} else {
				centerX = view.x;
				centerY = (opts.position === 'top') ? box.top : box.bottom;

				if (centerX < box.left || box.right < centerX) {
					return;
				}
			}

			// 画像
			var image = me.image;

			// 画像切り抜き範囲
			var clipRect = opts.clipRect;
			var iOffsetX, iOffsetY, iWidth, iHeight;

			if (clipRect) {
				iOffsetX = clipRect.x || 0;
				iOffsetY = clipRect.y || 0;
				iWidth = clipRect.width || (image.width - iOffsetX);
				iHeight = clipRect.height || (image.height - iOffsetY);
			} else {
				iOffsetX = iOffsetY = 0;
				iWidth = image.width;
				iHeight = image.height;
			}

			// 画像の描画座標
			var x, y;
			if (isHorizontal) {
				x = Math.round(centerX);
				y = Math.round(centerY - iHeight / 2);
			} else {
				x = Math.round(centerX - iWidth / 2);
				y = Math.round(centerY - iHeight);
			}

			// 画像を描画する。
			ctx.save();
			ctx.drawImage(image, iOffsetX, iOffsetY, iWidth, iHeight, x, y, iWidth, iHeight);
			ctx.restore();
		};

		return ImageManager;
	})();

	// データマーカープラグイン本体
	var blenderDataMarkerPlugin = {

		// プラグインを一意に識別するためのIDの
		id: 'blenderdatamarker',

		// 画像管理の初期化
		beforeInit: function(chart, options) {
			chart.blendarMarkerImageManager = new ImageManager(chart, options.imageUrl);
		},

		// 更新前処理
		// 画像URLを同期する
		beforeUpdate: function(chart, options) {
			chart.blendarMarkerImageManager.setUrl(options.imageUrl);
		},

		// グラフデータ描画後の処理
		// データマーカの描画を行う。
		afterDatasetsDraw: function(chart, easingValue, options) {
			var imgMan = chart.blendarMarkerImageManager;
			imgMan.setRequestRendering();

			if (!imgMan.isComplete()) {
				return;
			}
			var chartData = chart.data;
			var datasets = chartData.datasets;
			var drawMarker = this._drawMarker;

			for (var dsi = 0, dsLen = datasets.length; dsi < dsLen; dsi++) {
				if (!chart.isDatasetVisible(dsi)) {
					// 非表示の系列は無視。
					continue;
				}

				// 1系列分のデータ
				var data = datasets[dsi].data;
				// ↑のメタデータ
				var datasetMeta = chart.getDatasetMeta(dsi);

				for (var di = 0, dLen = data.length; di < dLen; di++) {
					drawMarker(chart, options.markers, di, data, datasetMeta);
				}
			}
		},

		// マーカーの描画処理
		_drawMarker: function(chart, markers, index, data, meta) {
			var imgMan = chart.blendarMarkerImageManager;
			var ctx = chart.ctx;
			var chartArea = chart.chartArea;
			var element = meta.data[index];

			var callbackParam = {
				index: index,
				datasetIndex: element._datasetIndex,
				value: data[index],
				values: data,
				type: meta.type
			};

			var marker;

			for (var i = 0, ilen = markers.length; i < ilen; i++) {
				marker = markers[i];

				if (helpers.callback(marker.callback, [callbackParam], chart)) {
					imgMan.draw(ctx, chartArea, element._view, marker);
				}
			}
			return true;
		}
	};

	// プラグインのデフォルトのオプションを登録
	Chart.defaults._set('global', {
		plugins: {
			blenderdatamarker: {
				markers: []
			}
		}
	});

	// プラグインを登録する。
	Chart.plugins.register(blenderDataMarkerPlugin);

})();

/*
Copyright MITSUBISHI Elec.
*/